import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";
import { getColumnIntoKey } from "~pages/PriceSearchV2/utils/initializerHelpers";

const usePesquisaProdutos = (formikRef, grupoMaterialId = 0) => {
  const pesquisaProdutoSelect = useSelect("pesquisaProdutos");
  const [pesquisaProduto, setPesquisaProduto] = useState(null);
  const [pesquisaProdutoObjeto, setPesquisaProdutoObjeto] = useState({});
  const [fila, setFila] = useState(null);

  const [pesquisaProdutos, setPesquisaProdutos] = useState([]);

  useEffect(() => {
    const fetchPesquisaProdutos = async () => {
      const produtos = [];
      await db.pesquisaProdutos.each((produto) => {
        produtos.push(produto);
      });
      setPesquisaProdutos(produtos);
    };

    fetchPesquisaProdutos();
  }, []);

  const optionPesquisaProduto = useMemo(() => {
    let temp = [];
    if (grupoMaterialId && grupoMaterialId != 0) {
      temp = (pesquisaProdutos || []).filter((e) => e.ativo && e.pesquisaGrupoMaterialId == grupoMaterialId);
    }

    return prepareForOptions(temp, ["nome"], "id");
  }, [pesquisaProdutos, grupoMaterialId]);

  useEffect(() => {
    if (fila && pesquisaProdutos && pesquisaProdutos.length > 0) {
      setPesquisaProdutoSelect(fila);
    }

    if (pesquisaProdutos?.length > 0) {
      setPesquisaProdutoObjeto(getColumnIntoKey({ data: pesquisaProdutos, prefix: "id-" }));
    }
  }, [fila, pesquisaProdutos]);

  useEffect(() => {
    if (grupoMaterialId && grupoMaterialId != 0) {
      const exists = (pesquisaProdutos || []).find(
        (e) => e.id == pesquisaProduto && e.pesquisaGrupoMaterialId == grupoMaterialId
      );

      if (!exists) {
        onChangePesquisaProduto({
          value: null,
        });
      }
    }
  }, [grupoMaterialId, pesquisaProduto]);

  function setPesquisaProdutoSelect(value) {
    if (pesquisaProdutos && pesquisaProdutos.length > 0) {
      const optionProduto = (pesquisaProdutos || []).find((optProduto) => optProduto.id == value);

      if (optionProduto) {
        onChangePesquisaProduto({
          label: optionProduto.nome,
          value: optionProduto.id,
        });
      }
    } else {
      setFila(value);
    }
  }

  function onChangePesquisaProduto(e) {
    pesquisaProdutoSelect.upDateValue(e.value);
    pesquisaProdutoSelect.upDateDefaultValue(e || "");
    const formikInstance = formikRef?.current;
    if (formikInstance) {
      formikInstance.setFieldValue("produtoId", e.value);
      e.value && setTimeout(() => formikInstance.setFieldTouched("produtoId", true));
    }
    setPesquisaProduto(e.value);
  }

  return {
    pesquisaProdutoObjeto,
    pesquisaProduto,
    optionPesquisaProduto,
    onChangePesquisaProduto,
    pesquisaProdutos,
    pesquisaProdutoSelect,
    setPesquisaProduto,
    setPesquisaProdutoSelect,
  };
};

export default usePesquisaProdutos;
